import { render, staticRenderFns } from "./AnnotationNote.vue?vue&type=template&id=0a26fa3a&scoped=true"
import script from "./AnnotationNote.vue?vue&type=script&lang=js"
export * from "./AnnotationNote.vue?vue&type=script&lang=js"
import style0 from "./AnnotationNote.vue?vue&type=style&index=0&id=0a26fa3a&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a26fa3a",
  null
  
)

export default component.exports